<template>
<BootstrapDialog title="抓拍照片详情" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-6" style="text-align: center">
		            <img :src="xcpz" alt="" style="height: 200px;width: 175px">
		            <h4 style="text-align: center">考生照片</h4>
		        </div>
		        <div class="col-sm-6">
		            <!--预览 v-if-->
		            <div class="photoPreview" style="text-align: center">
		                <img :src="photoPreview" alt="" style="height: 200px;width: 175px">
		                <h4 style="text-align: center">选中照片</h4>
		            </div>
		            <!--v-if-->
		            <!--<div class="noPhoto" style="text-align: center;height: 200px;line-height: 200px">-->
		            <!--没有抓拍相片！-->
		            <!--</div>-->
		        </div>
		    </div>
		    <div class="row">
		        <div class="somePhotos">
		            <div v-for="item in photoList" :key="item.id"  @click="showPreview(item.url)" class="photoClass" style="width: 120px;height: 150px;float: left;padding: 5px">
		                <img style="width: 100%;height: 100%"
		                     :src="item.url" alt="">
		            </div>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button  class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 综合测验 抓拍
     */
    export default {
        name: 'ExamYzZhuapai',
        data: function () {
            return {
                xcpz:'',
                photoPreview:'',
                photoList:[],
                query: {
                    ksId: '',
                    ksjlId: ''
                }
            }
        },
        methods: {
			reset:function(){
				this.xcpz = '';
				this.photoPreview = '';
				this.photoList = [];
				this.query = {
					ksId: '',
					ksjlId: ''
				}
			},
			async open(params){
				this.query.ksId = params.ksId;
				this.query.ksjlId = params.ksjlId;
				let res =await this.$http.post('/htgl/biz/zypx/zhcyyzjl/xqByZp',this.query);
				if(res.data){
					let data = res.data;
					this.xcpz = data.xcpz;
					this.photoList = data.kszpList;
					this.photoList.forEach((item, index) => {
						if(index == 0){
							this.showPreview(item.url)
						}
					});
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            showPreview:function(url){
                this.photoPreview = url;
            }
        }

    }
</script>